import * as React from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import { StringConstants } from '../../../containers/WorkkardDetail/constants';
class Base extends React.Component{
    constructor(props){
        super(props);
    }
    componentDidUpdate(prevProps){
        if(!Array.isArray(this.props.data) && this.props.data!=prevProps.data && this.props?.timeZoneValue?.trim("")==""){
            if( this.props.data.FieldKey.includes("timezone")){
                const fieldSetting = this.props.data.FieldSettings ? JSON.parse(this.props.data.FieldSettings) : {};
                const timeZoneFrom = fieldSetting.timezone_from.split("/");
                let zipcode;
                if(timeZoneFrom.length == 2){
                    if(timeZoneFrom[0] == StringConstants.workkard){
                        this.props.customFieldsData.wrkdDetail.map(item=>{
                            if(item.FieldType=="zip"){
                                zipcode = item.Value
                            }
                        })
                    }else if(timeZoneFrom[0] == StringConstants.activity){
                        this.props.customFieldsData.actDetail.map(item=>{
                            if(item.FieldType=="zip"){
                                zipcode = item.Value
                            }
                        })
                    }
                    this.props.getTimezoneByZip({zip:zipcode});
                }
            }
        }
    }
    parseCustomFileds (fieldData, fieldIdentifier, group) {
        return fieldData.filter((obj) => (obj.Name.includes(fieldIdentifier) && obj.Group == group));
    }

    renderOnCard() {
        return (
            <div>String on card</div>
        )
    }
    renderOnGrid() {
        return (
            <div>String on grid</div>
        )
    }
    renderOnDetail() {
        return (
            <div>String on detail</div>
        )
    }

    renderOnCreate() {
        return (
            <div>String on create</div>
        )
    }

    renderField() {
        switch (this.props.renderLocation.toLowerCase()) {
            case "card":
                return this.renderOnCard();
            case "grid":
                return this.renderOnGrid();
            case "detail":
                return this.renderOnDetail();
            case "create":
                return this.renderOnCreate();
        }
    }

    runPreScript() {
        console.log("Base PreScript code")
    }

    runPostScript() {
        console.log("Base PostScript code")
    }

    render() {
        return this.renderField();
    }
}

export default Base;